export enum DataRoomActionTypes {
  Hide,
  HideRestoreOrDelete,
  CopyLink,
  Delete,
  Details,
  Duplicate,
  Export,
  ExportFromEnclave,
  OpenPublishedAndProtectedDialog,
  Publish,
  Rename,
  Restore,
  RestoreOrDelete,
  ShowOrganizationLogo,
  ToggleFavorite,
  Validate,
  Stop,
  EnableExpertView,
  RequirePassword,
}
